module.exports = __webpack_public_path__ + "img/gyra_banner@3x.82f84c8d.png";